import { action, computed, makeObservable, observable } from 'mobx';

export type SortDirection = 'ascending' | 'descending';

export interface SortDescriptor {
  column: string;
  direction: SortDirection;
}

export default class SortState {
  @observable public column: string;
  @observable public direction: SortDirection;

  public constructor(column: string, direction: SortDirection = 'ascending') {
    this.column = column;
    this.direction = direction;

    makeObservable(this);
  }

  @computed
  public get descriptor(): SortDescriptor {
    return { column: this.column, direction: this.direction };
  }

  @action.bound
  public setSort(column: string, direction: SortDirection): void {
    this.column = column;
    this.direction = direction;
  }
}
